import { render } from "./TopbarView.vue?vue&type=template&id=298bacd6"
import script from "./TopbarView.vue?vue&type=script&lang=js"
export * from "./TopbarView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__